import { getMeetingsFilterMenuPortalRoot } from 'components/meetings/filter_modal/filter_menu_portal_root'

import { getSchedulingFilterMenuPortalRoot } from './filter_menu_portal_root'

/** Ensures both scheduling and meetings portal roots exist (field menus may use either). */
export const ensureFilterMenuPortalRoots = () => {
  getSchedulingFilterMenuPortalRoot()
  getMeetingsFilterMenuPortalRoot()
}

export const getFilterMenuPortalRoots = () => [
  getSchedulingFilterMenuPortalRoot(),
  getMeetingsFilterMenuPortalRoot(),
].filter(Boolean)
